import {formatPrice, formatPriceZero} from "../domains2/libraries/Utils";
import appConfig from "../appconfig";
import {mapGetters} from "vuex";
import {getProductPriceWithDiscounts} from "../libraries/globalTemplateSpecific/bm100/utils";
import ProductSelection from "../domains2/orders/ProductSelection";
import {generateOrderLines} from "../integrations/tracking/gtm/gtmHelper";

const tenantConfig = appConfig.tenantConfig;
export default {
	props: ["group", "subProduct", "mainGroup", "productSelection", "changeSubGroupProductSelection"],
	data() {
		return {
			productSelectionState: {...this.productSelection},
			timeoutHandle: null,
			cartQuantityDialogShown: false
		};
	},
	computed: {
		...mapGetters(["productCatalog", "groupsWithMandatoryProductSelection"]),
		isGroupWithMandatorySelections() {
			return !!this.checkIfGroupHasSelectionRestrictions(this.group);
		},
		shouldApplyDiscount() {
			if(!this.product.discount) {
				return false;
			}
			const orderLine = generateOrderLines(
				this,
				{
					productCatalog: this.productCatalog,
					productSelections: [ProductSelection.createFromProduct(this.product)],
					...(this.rootProduct && this.rootProduct.departmentId === 2 && { isRootProductMenu: true })
				}
			)[0];
			if(!orderLine || !orderLine.discount) {
				return false;
			}
			// NOTE: this is not the way that we should handle discounts, but I don't have capacity to refactor it now
			// products should have a correct reference to the applied discount
			// but presently it can be any discount that is active in the system and has the product in its scope
			// so the logic for getPriceInGroup can pick up a discount that is not really applied to the product
			// order lines handle discounts correctly so I will use them as a reference, but this must be fixed in the future
			return this.product.discount.discountId === orderLine.discount.discountId;
		},
		subproductPrice() {
			const self = this;
			const priceInGroup = this.rootProduct && self.product.priceStructure
				? self.product.priceStructure.defaultPrice
				: self.product.getPriceInGroup({
					applyDiscount: this.shouldApplyDiscount
				});
			const priceFloat = parseFloat(priceInGroup);
			const price = isNaN(priceFloat) ? 0 : priceFloat;
			const formattedPrice = self.precisionTwoWithZeros ? formatPriceZero(price) : formatPrice(price);
			return self.group.options.customPriceLabel ? `${formattedPrice} ${self.group.options.customPriceLabel}` : formattedPrice;
		},
		precisionTwoWithZeros() {
			return tenantConfig.precisionTwoWithZeros;
		},
		shouldShowDiscountedPrice() {
			return this.product.discount && this.product.discount.voucherPattern.length === 0;
		},
		discountPrice() {
			const productWithDiscountedPrice = getProductPriceWithDiscounts(
				[this.product],
				[ProductSelection.createFromProduct(this.product)],
				this.productCatalog,
				["familyDiscount"]
			);
			return productWithDiscountedPrice[this.product.id] && formatPriceZero(productWithDiscountedPrice[this.product.id].discountPrice);
		}
	},
	methods: {
		doNothing(){},
		checkIfGroupHasSelectionRestrictions(group) {
			return this.groupsWithMandatoryProductSelection[group.id];
		},
		manageMandatoryProductSelections() {
			/**
			 *  This function manages selection when there is mandatory selection. It covers 2 possible scenarios:
			 * 1) There are some selections inside group. If user chooses "No thanks" option, function should deselect all previously selected products automatically.
			 * 2) "No thanks" is chosen. If user chooses something else, function should deselect "No thanks" automatically.
			 */
			const self = this;
			const mainProductSelection = self.subProduct ? self.productSelectionState.groups
				.find(g => g.selectedProducts.find(sp => sp.productId === self.group.productId)).selectedProducts[0] : self.productSelectionState;
			const selectedProducts = mainProductSelection.groups
				.find(g => g.groupId === self.group.id).selectedProducts;
			self.changeSubGroupProductSelection(self.mainGroup, self.subProduct, self.group, selectedProducts);
		},
		resetTimeout() {
			const self = this;
			window.clearTimeout(self.timeoutHandle);
			self.timeoutHandle = window.setTimeout(() => {
				self.cartQuantityDialogShown = false;
			}, 3000);
		}
	}
};
